import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export type overlayScreenComponent =
  // | "CategoryFilter"
  // | "DateFilter"
  // | "Sort"
  // | "ExclusiveCategoryFilter"
  // | "StartTour"
  // | "ArrivedAtStop"
  // | "LanguageSelector"
  // | "GoalRedemption"
  "PlanDatePicker" | "PlanAddToDatePicker" | "StartingPoint";
// | "Note"
// | "GroupPlan"
// | "MapType"
// | "Rating"
// | "CheckInCode"
// | "OneTimePassword"
// | "SocialShare";

export interface AppState {
  overlayScreen?: {
    name: overlayScreenComponent;
    params?: {
      [key: string]: string | number | string[] | number[] | null | undefined;
    };
  };
  isHeaderVisible: boolean;
}

const initialState: AppState = {
  isHeaderVisible: true,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setOverlayScreenAction: (
      state,
      action: PayloadAction<
        | {
            name: overlayScreenComponent;
            params?: {
              [key: string]:
                | string
                | number
                | string[]
                | number[]
                | undefined
                | null;
            };
          }
        | undefined
      >,
    ) => {
      state.overlayScreen = action.payload;
    },
    setIsHeaderVisibleAction: (state, action: PayloadAction<boolean>) => {
      state.isHeaderVisible = action.payload;
    },
  },
});

export const selectOverlayScreen = (state: RootState) => {
  return state.app.overlayScreen;
};

export const selectIsHeaderVisible = (state: RootState) => {
  return (
    state.app.isHeaderVisible && !state.client.embeddedViewOptions.isHideHeader
  );
};

export const { setOverlayScreenAction, setIsHeaderVisibleAction } =
  appSlice.actions;

// eslint-disable-next-line import/no-default-export
export default appSlice.reducer;
